export const modules = [
  {
    title: "AI voice agents",
    body: "Answer every call, book jobs, capture intent, and hand off cleanly to humans — day or night.",
  },
  {
    title: "Dispatch & routing",
    body: "Board, capacity, skills, and AI-assisted assignment so the right tech lands on the right job.",
  },
  {
    title: "CRM & pipeline",
    body: "Customers, properties, equipment history, and sales follow-ups in one living record.",
  },
  {
    title: "Estimates & invoices",
    body: "Pricebook-driven quotes, approvals, deposits, and invoices that close without retyping.",
  },
  {
    title: "Agreements & memberships",
    body: "Maintenance plans, renewals, and recurring revenue tracked against real service history.",
  },
  {
    title: "Inventory",
    body: "Parts, truck stock, POs, and job consumption without spreadsheet archaeology.",
  },
  {
    title: "Accounting",
    body: "Job costing, revenue recognition, and books that finally match the field.",
  },
  {
    title: "Marketing automation",
    body: "Campaigns, reviews, and nurture sequences that turn booked work into repeat work.",
  },
  {
    title: "Workforce",
    body: "Schedules, time, and capacity planning that keep crews productive without burnout.",
  },
];

export const pillars = [
  {
    eyebrow: "Office",
    title: "ServiTrex",
    body: "Run the business from one multi-tenant command center — CSR tools, dispatch, CRM, money, and marketing.",
    href: "/product/office",
    cta: "Explore the office product",
  },
  {
    eyebrow: "Field",
    title: "TrexField",
    body: "Give technicians a mobile app built for job execution, diagnostics, photos, payments, and clean closeout.",
    href: "/product/field",
    cta: "See TrexField",
  },
  {
    eyebrow: "Voice",
    title: "AI agents that answer",
    body: "Never miss a lead. AI voice agents book, triage, and transfer with full context into ServiTrex.",
    href: "/demo",
    cta: "Request a live demo",
  },
];

export const proofPoints = [
  "Built for multi-brand home-service groups",
  "AI voice + human handoff in one stack",
  "Office and field sharing the same source of truth",
  "Accounting, inventory, and memberships optional by plan",
];
